<template>
  <div id="qrcode-deail">
    <v-container grid-list-xl px-4>
      <ProductDetail :qrcodeId="qrcodeId" />
      <FarmDetail :qrcodeId="qrcodeId" class="mt-4" />
      <PackingDetail :qrcodeId="qrcodeId" class="mt-4" />
      <TradeDetail :qrcodeId="qrcodeId" class="mt-4" />
      <MarketDetail :qrcodeId="qrcodeId" class="mt-4" />
    </v-container>
  </div>
</template>

<script>
const ProductDetail = () => import('@/components/qrcode/ProductDetail')
const FarmDetail = () => import('@/components/qrcode/FarmDetail')
const PackingDetail = () => import('@/components/qrcode/PackingDetail')
const TradeDetail = () => import('@/components/qrcode/TradeDetail')
const MarketDetail = () => import('@/components/qrcode/MarketDetail')

export default {
  name: 'qrcode-deail',
  components: {
    ProductDetail,
    FarmDetail,
    PackingDetail,
    TradeDetail,
    MarketDetail
  },
  computed: {
    qrcodeId() {
      return this.$route.params.qrcodeId
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
